import * as React from "react";
import Popover from "@mui/material/Popover";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import IconButton from "@mui/material/IconButton";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";

export default function BasicPopover() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton
        color="primary"
        size="sm"
        title="Info"
        style={{
          padding: "0px",
          color: "lightgreen",
        }}
        onClick={handleClick}
      >
        <InfoTwoToneIcon fontSize="small" color="primary" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Card>
          <CardContent>
            <Typography>
              ┌───────────── minute (0 - 59)
              <br />
              │ ┌───────────── hour (0 - 23)
              <br />
              │ │ ┌───────────── day of the month (1 - 31)
              <br />
              │ │ │ ┌───────────── month (1 - 12)
              <br />
              │ │ │ │ ┌───────────── day of the week (1 - 7) (Sunday to
              Saturday)
              <br />
              │ │ │ │ │
              <br />
              │ │ │ │ │
              <br />
              │ │ │ │ │
              <br />* * * * *
            </Typography>
            <Typography>
              For example, the below cron expression will execute the audit on
              first day of every month at 00:00 AM UTC:
            </Typography>
            <Typography>
              <span style={{ color: "red" }}>0 0 1 * *</span>
            </Typography>
          </CardContent>
        </Card>
      </Popover>
    </div>
  );
}